// export { default as Home } from './Home';
// export { default as Intro } from './Intro';
// export { default as Playlist } from './Playlist';

import React from 'react';
import Loadable from 'react-loadable';

const Loading = () => {
  // return <div>로딩중</div>;
  return <div />;
};

export const Test = Loadable({
  loader: () => import('./Test'),
  loading: Loading,
});

export const DesktopOnly = Loadable({
  loader: () => import('./DesktopOnly'),
  loading: Loading,
});

export const MySetting = Loadable({
  loader: () => import('./my/Setting'),
  loading: Loading,
});

export const Home = Loadable({
  loader: () => import('./Home'),
  loading: Loading,
});

export const Intro = Loadable({
  loader: () => import('./Intro'),
  loading: Loading,
});

export const Playlist = Loadable({
  loader: () => import('./Playlist'),
  loading: Loading,
});

export const Tutorial = Loadable({
  loader: () => import('./Tutorial'),
  loading: Loading,
});

export const Download = Loadable({
  loader: () => import('./Download'),
  loading: Loading,
});

export const FreeExperience = Loadable({
  loader: () =>
    import(
      '../../pages/freeexperience/containers/freeexperience/FreeExperience'
    ),
  loading: Loading,
});

export const PurchaseProducts = Loadable({
  loader: () => import('./introduce/purchase/pay/Products'),
  loading: Loading,
});

export const PurchaseProduct = Loadable({
  loader: () => import('./introduce/purchase/pay/Product'),
  loading: Loading,
});

export const PurchaseRepayProductDetail = Loadable({
  loader: () => import('./introduce/purchase/repay/RepayProduct'),
  loading: Loading,
});

export const PurchaseHistory = Loadable({
  loader: () => import('./introduce/purchase/History'),
  loading: Loading,
});

export const PurchaseFailure = Loadable({
  loader: () =>
    import('../../web/routes/introduce/purchase/result/FailurePage'),
  loading: Loading,
});
export const PurchaseSuccess = Loadable({
  loader: () =>
    import('../../web/routes/introduce/purchase/result/SuccessPage'),
  loading: Loading,
});

//환급챌린지 소개
export const MyChallenge = Loadable({
  loader: () => import('./my/challenge/Challenge'),
  loading: Loading,
});

//환급 챌린지
export const MyMission = Loadable({
  loader: () => import('./my/challenge/Mission'),
  loading: Loading,
});

//환급 챌린지 진행내역
export const MyProgress = Loadable({
  loader: () => import('./my/challenge/Progress'),
  loading: Loading,
});

//환급 챌린지 필요서류등록
export const MyNeedPaper = Loadable({
  loader: () => import('./my/challenge/Paper'),
  loading: Loading,
});

export const AppDownload = Loadable({
  loader: () => import('./DownloadApp'),
  loading: Loading,
});

export const Customer = Loadable({
  loader: () => import('./Customer'),
  loading: Loading,
});

export const Manual = Loadable({
  loader: () => import('./Manual'),
  loading: Loading,
});

export const SongsCopyRight = Loadable({
  loader: () => import('./SongsCopyRight'),
  loading: Loading,
});

// 404 Page
export const NotFoundMobile = Loadable({
  loader: () => import('./NotFoundMobile'),
  loading: Loading,
});
